import { render, staticRenderFns } from "./activitydetails.vue?vue&type=template&id=417bb4f4&scoped=true"
import script from "./activitydetails.vue?vue&type=script&lang=js"
export * from "./activitydetails.vue?vue&type=script&lang=js"
import style0 from "./activitydetails.vue?vue&type=style&index=0&id=417bb4f4&prod&scoped=true&lang=css"
import style1 from "./activitydetails.vue?vue&type=style&index=1&id=417bb4f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417bb4f4",
  null
  
)

export default component.exports